import { gql } from '@apollo/client';

export const PREVIEW_URL_STATUS = gql`
  query PreviewUrlStatus($url: String!) {
    previewUrlStatus(url: $url) {
      status
    }
  }
`;
